import axios from "axios";
import Swal from 'sweetalert2';

const state = {
    sourceList: [],
    sourceArr: [],
    sourceArray: [],
    sourceID: "",
    selectedSource: null,
    isEditing: "",
  };
  
  const mutations = {
    initializeStore(state){
      state.sourceList = [];
      state.sourceArr = [];
      state.sourceArray = [];
      state.sourceID = '';
      state.selectedSource = null;
      state.isEditing = false;
    },
    SET_SELECTED_SOURCE(state, source) {
      state.selectedSource = source;
      state.isEditing = true;
    },
    SOURCES_ARRAY(state, sources){
      state.sourceArray = sources;
    },
    LIST_LEAD_SOURCES(state, sources) {
      state.sourceList = sources;
    },
    SET_STATE(state, payload) {
      for (const key in payload) {
          if (payload.hasOwnProperty(key) && key in state) {
              state[key] = payload[key];
          }
      }
    },
    SET_SEARCH_FILTERS(state, search_filter){
      for(const [key, value] of Object.entries(search_filter)){
        
      }
    },
    RESET_SEARCH_FILTERS(state){
      
    }

  };
  
  const actions = {
    updateState({ commit }, newState) {
      commit('SET_STATE', newState);
    },
    
    async createLeadSource({ commit,state }, formData) {
      return axios.post('api/v1/create-lead-source/', formData)
      .then((response)=>{
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })
    },
  
    fetchLeadSources({ commit,state }, formData) {
      state.sourceArr = [];
      axios.post(`api/v1/get-lead-sources/`,formData)
      .then((response)=>{
        for(let i=0; i< response.data.length; i++){
          state.sourceArr.push((response.data[i].name));
        }
        commit('LIST_LEAD_SOURCES', response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    fetchLeadSource({ commit,state }, formData) {
      axios.post(`api/v1/get-lead-sources/`,formData)
      .then((response)=>{
        state.selectedSource = response.data;
        commit('SET_SELECTED_SOURCE',response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    handleSelectedSource({ commit, state }, option){
      state.sourceArray = [];
      const selectedSource = state.sourceList.find(source => (source.name) === option);
      if (selectedSource) {
          state.sourceID = selectedSource.lead_source_id;
          state.sourceArray = [...state.sourceArray, selectedSource];
      }
      commit('SOURCES_ARRAY', state.sourceArray);
        
    },
  
    async updateLeadSource({ commit,state }, formData) {
      return axios.put(`api/v1/update-lead-source/`,formData)
      .then((response)=>{
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })  
    },
  
    deleteLeadSource({ commit,state }, formData) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you wish to delete Source?`,
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Yes Delete Source!',
        cancelButtonText: 'Cancel!',
        customClass: {
            confirmButton: 'swal2-confirm-custom',
            cancelButton: 'swal2-cancel-custom',
        },
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          axios.post(`api/v1/delete-lead-source/`,formData)
          .then((response)=>{
            if(response.status == 200){
                Swal.fire("Poof! Source removed succesfully!", {
                  icon: "success",
                }); 
            }else{
              Swal.fire({
                title: "Error Deleting Source",
                icon: "warning",
              });
            }                   
          })
          .catch((error)=>{
            console.log(error.message);
            Swal.fire({
              title: error.message,
              icon: "warning",
            });
          })
        }else{
          Swal.fire(`Source has not been deleted!`);
        }
      })
    },
  };
  
  const getters = {
    // users: (state) => state.users,
    // currentUser: (state) => state.currentUser,
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  
  